module.exports = new __parcel__URL__("octo-header.4542a070.mp4").toString();